import axios from 'axios';
import { resolveBaseUrl } from './api';

export interface DemoLlmResponse {
  request_id: string;
  response: string;
  model: string;
  cost: number;
  strategy: string;
  route: 'weak' | 'strong' | 'cache';
  is_cache_hit: boolean;
  router_latency_ms?: number;
  llm_response_time_ms?: number;
  llm_latency_ms?: number;
  usage: {
    prompt_tokens: number;
    completion_tokens: number;
  };
}

interface DemoLlmOptions {
  skip_cache?: boolean;
}

const demoApi = axios.create({
  baseURL: resolveBaseUrl(),
});

export const proxyDemoLlm = async (
  model: string | undefined,
  prompt: string,
  options?: DemoLlmOptions
): Promise<DemoLlmResponse> => {
  const response = await demoApi.post<DemoLlmResponse>('/api/demo/llm', { model, prompt, options });
  return response.data;
};
